var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"}},[_c('path',{attrs:{"d":"M3 4.5L6 7.5L9 4.5","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }